import { render, staticRenderFns } from "./OrdinalInner.vue?vue&type=template&id=5acc1eef&scoped=true"
import script from "./OrdinalInner.vue?vue&type=script&lang=js"
export * from "./OrdinalInner.vue?vue&type=script&lang=js"
import style0 from "./OrdinalInner.vue?vue&type=style&index=0&id=5acc1eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acc1eef",
  null
  
)

export default component.exports